import React from 'react'

const LightningCharge = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_219_3302)">
        <path
          d="M18.283 0.110485C18.442 0.202685 18.5651 0.346094 18.6321 0.517284C18.6991 0.688474 18.706 0.877325 18.6518 1.05299L15.7252 10.5625H21.1251C21.2838 10.5624 21.439 10.6088 21.5716 10.696C21.7042 10.7831 21.8084 10.9072 21.8713 11.0529C21.9342 11.1986 21.9531 11.3595 21.9256 11.5158C21.8981 11.6721 21.8254 11.8169 21.7166 11.9324L8.71658 25.7449C8.59079 25.8786 8.42341 25.9658 8.24171 25.9923C8.06001 26.0187 7.87472 25.9828 7.71602 25.8905C7.55732 25.7981 7.43459 25.6548 7.36782 25.4837C7.30104 25.3127 7.29418 25.1241 7.34833 24.9486L10.275 15.4375H4.87508C4.71639 15.4375 4.56116 15.3911 4.42854 15.304C4.29592 15.2168 4.19173 15.0928 4.12882 14.9471C4.06592 14.8014 4.04705 14.6405 4.07455 14.4842C4.10205 14.3279 4.17472 14.1831 4.28358 14.0676L17.2836 0.25511C17.4092 0.121534 17.5763 0.0343844 17.7578 0.0078318C17.9392 -0.0187208 18.1243 0.0168852 18.283 0.10886V0.110485ZM6.75521 13.8125H11.3751C11.5022 13.8125 11.6276 13.8423 11.7411 13.8995C11.8547 13.9568 11.9532 14.0399 12.0287 14.1422C12.1043 14.2445 12.1548 14.363 12.1762 14.4884C12.1975 14.6137 12.1892 14.7423 12.1518 14.8639L9.92883 22.0837L19.2433 12.1875H14.6251C14.4979 12.1875 14.3725 12.1577 14.259 12.1004C14.1455 12.0432 14.047 11.9601 13.9714 11.8578C13.8959 11.7555 13.8454 11.6369 13.824 11.5116C13.8026 11.3863 13.8109 11.2576 13.8483 11.1361L16.0713 3.91624L6.75521 13.8125Z"
          fill="#1772F5"
        />
      </g>
      <defs>
        <clipPath id="clip0_219_3302">
          <rect
            width="26"
            height="26"
            fill="white"/>
        </clipPath>
      </defs>
    </svg>
  )
}

export default LightningCharge;
